import { render, staticRenderFns } from "./Bathrooms.vue?vue&type=template&id=4e2a4552&"
import script from "./Bathrooms.vue?vue&type=script&lang=ts&"
export * from "./Bathrooms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports